(() => {
  'use strict';
  document.querySelectorAll('[data-gameday-usa-upsell]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const select = root.querySelector('[data-usa-size]'), button = root.querySelector('[data-usa-add]');
    const status = root.querySelector('[data-usa-status]'), cartLink = root.querySelector('[data-usa-cart]');
    const price = root.querySelector('[data-usa-price]'), fit = root.querySelector('[data-usa-fit]');
    const baseFit = fit.textContent, links = [...root.querySelectorAll('[data-usa-link]')];
    const productUrl = new URL(links[0].href, location.href);
    const shopRoot = root.dataset.shopRoot || '/';
    let manual = false, busy = false, lastMatch = '';
    let parent = {variants: []};
    try { parent = JSON.parse(root.querySelector('[data-usa-parent]')?.textContent || '{"variants":[]}'); } catch (_) { /* No parent on collection pages. */ }
    const sizeKey = (value) => String(value || '').toLowerCase().replace(/×/g, 'x').replace(/\s/g, '').match(/\d+(?:\.\d+)?x\d+(?:\.\d+)?/)?.[0] || '';
    const current = () => select.selectedOptions[0];
    const refresh = () => {
      const option = current();
      button.disabled = busy || option?.dataset.purchasable !== 'true';
      price.textContent = option?.dataset.price || '';
      button.firstChild.textContent = busy ? 'ADDING… ' : option?.dataset.purchasable === 'true' ? 'ADD AMERICAN FLAG ' : 'CURRENTLY UNAVAILABLE ';
      links.forEach((link) => { const url = new URL(productUrl); if (option) url.searchParams.set('variant', option.value); link.href = url.href; });
    };
    const matchSize = () => {
      if (manual || busy || !parent.variants.length) return;
      const custom = document.querySelector('[data-custom-size].is-active, [data-custom-size][aria-pressed="true"]');
      const ids = [...document.querySelectorAll('#MainContent [name="id"], [data-authentic-variant-id], [data-product-variant]')];
      const id = ids.map((el) => el.value).find((value) => parent.variants.some((variant) => String(variant.id) === String(value))) || parent.initial;
      const variant = parent.variants.find((item) => String(item.id) === String(id));
      const key = sizeKey(custom?.dataset.customSize || variant?.title);
      if (key === lastMatch) return;
      lastMatch = key;
      const option = [...select.options].find((item) => sizeKey(item.dataset.title) === key);
      if (option) { select.value = option.value; fit.textContent = `Matches your ${option.dataset.title} flag selection. ${baseFit}`; refresh(); }
      else if (key) { fit.textContent = `No exact American flag size matches this selection. Choose a size for your pole. ${baseFit}`; }
    };
    select.addEventListener('change', () => { manual = true; status.textContent = ''; fit.textContent = baseFit; refresh(); });
    const parentChanged = (event) => { if (!root.contains(event.target)) setTimeout(matchSize, 0); };
    if (parent.variants.length) { document.addEventListener('change', parentChanged); document.addEventListener('click', parentChanged); }
    button.addEventListener('click', async () => {
      const option = current();
      if (busy || option?.dataset.purchasable !== 'true') return;
      const id = Number(option.value), title = option.dataset.title;
      if (!Number.isSafeInteger(id) || id <= 0) return;
      busy = true; select.disabled = true; status.textContent = ''; refresh();
      try {
        const response = await fetch(`${shopRoot}cart/add.js`, {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items: [{id, quantity: 1}]})});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'This size could not be added. Please check availability.');
        status.textContent = `${title} American flag added to your cart.`;
        cartLink.hidden = false;
        // Count refresh is separate: a failed read must never invite a duplicate add.
        try {
          const cartResponse = await fetch(`${shopRoot}cart.js`, {headers: {'Accept': 'application/json'}});
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            if (Number.isInteger(cart.item_count)) document.querySelectorAll('[data-header-cart-count]').forEach((el) => { el.textContent = cart.item_count; const link = el.closest('a'); if (link) link.setAttribute('aria-label', `Cart, ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`); });
          }
        } catch (_) { /* The add succeeded; keep its confirmation. */ }
      } catch (error) {
        status.textContent = error.message || 'Unable to confirm the add. Check your cart before trying again.';
        cartLink.hidden = false;
      } finally { busy = false; select.disabled = false; refresh(); }
    });
    refresh(); matchSize();
  });
})();
